// extracted by mini-css-extract-plugin
export default {"academyLatest":"styles_academyLatest__HP0tZ","academyLatestTitle":"styles_academyLatestTitle__AuukR","fadeIn":"styles_fadeIn__T4YKg"};